import { useEffect, useRef } from "react";
import { Bold, Italic, Link2, List } from "lucide-react";

const TOOLS = [["bold", Bold, "Bold"], ["italic", Italic, "Italic"], ["insertUnorderedList", List, "Bulleted list"]];

export default function RichTextEditor({ id, value, onChange, label }) {
  const ref = useRef(null);
  useEffect(() => {
    if (ref.current && ref.current.innerHTML !== value) ref.current.innerHTML = value || "";
  }, [value]);
  const exec = (cmd, arg) => { ref.current.focus(); document.execCommand(cmd, false, arg); onChange(ref.current.innerHTML); };
  const link = () => { const url = window.prompt("Link URL (https://…)"); if (url && /^(https?:|mailto:|\/)/.test(url)) exec("createLink", url); };
  return (
    <div className="rounded border border-slate-300" data-testid={`richtext-${id}`}>
      <div className="flex gap-1 border-b border-slate-200 bg-slate-50 p-1" role="toolbar" aria-label={`${label} formatting`}>
        {TOOLS.map(([cmd, Ico, name]) => (
          <button key={cmd} type="button" onMouseDown={(e) => e.preventDefault()} onClick={() => exec(cmd)} aria-label={name} className="rounded p-1.5 hover:bg-white"><Ico size={16} /></button>
        ))}
        <button type="button" onMouseDown={(e) => e.preventDefault()} onClick={link} aria-label="Insert link" className="rounded p-1.5 hover:bg-white"><Link2 size={16} /></button>
      </div>
      <div id={id} ref={ref} contentEditable role="textbox" aria-multiline="true" aria-label={label} suppressContentEditableWarning
        className="rich-text min-h-[120px] p-3 text-sm focus:outline-none" onInput={(e) => onChange(e.currentTarget.innerHTML)} />
    </div>
  );
}
